import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DateUtil } from 'src/app/util/date.util';
import { IonModal } from '@ionic/angular';
@Component({
  selector: 'app-date-model',
  templateUrl: './date-model.component.html',
  styleUrls: ['./date-model.component.scss'],
})
export class DateModelComponent  implements OnInit {

  @Input() label: string;
  @Input() model: any;
  @Input() minDate: any;
  @Input() maxDate: any;
  @Input() withTime: boolean = false;
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('dateModal') dateModal: IonModal;  
  modelString: string;
  tempDate: string;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model && changes.model.currentValue) {
      this.modelString = new Date(changes.model.currentValue).toISOString().split('T')[0];
    }
  }
  openModal() {
    this.dateModal.present(); // Open modal
  }

  closeModal() {
    this.dateModal.dismiss(); // Close modal
  }
  clearDate() {
    this.modelString = '';
    this.model = null;
    this.modelChange.emit(this.model);
    this.closeModal();
  }
  onChangeDate(event) {
    this.modelString = event.detail.value;
      this.model = DateUtil.convertStringToDate(this.modelString);
    console.log(this.model.toString());
    this.modelChange.emit(this.model);
  }
}
